import { isProjectId } from "../../shared/keys.ts";
import { projektAnlegen } from "./api.ts";

/**
 * Welches Projekt dieses Gerät gerade bearbeitet.
 *
 * ⚠️ **Die ID ist kein Geheimnis, das Cookie ist es.** Das Cookie ist `HttpOnly` und
 * für JavaScript unlesbar (`server/session.ts`); ohne es öffnet die ID gar nichts. Sie
 * steht hier nur, damit die Seite nach einem Neuladen weiß, **welches** ihrer Cookies
 * sie benutzen soll — die Adresse trägt sie in Schritt 2 noch nicht.
 */
const SCHLUESSEL = "collagen-planer:projekt";

function gemerkt(): string | null {
  try {
    const wert = localStorage.getItem(SCHLUESSEL);
    // Auch das Gemerkte wird geprüft. Wer im Entwicklerwerkzeug etwas anderes einträgt,
    // soll einen sauberen neuen Anfang bekommen und keinen Aufruf mit Unsinn im Pfad.
    return isProjectId(wert) ? wert : null;
  } catch {
    // Privater Modus, gesperrter Speicher: dann gibt es eben kein Gedächtnis.
    return null;
  }
}

function merken(id: string): void {
  try {
    localStorage.setItem(SCHLUESSEL, id);
  } catch {
    // Ohne Gedächtnis funktioniert alles bis zum nächsten Neuladen — das ist besser
    // als ein Fehler, der den Upload verhindert.
  }
}

/**
 * Die ID des laufenden Projekts — vorhanden oder frisch angelegt.
 *
 * Dass eine gemerkte ID noch gültig ist, beweist erst der nächste Aufruf: ist das
 * Cookie abgelaufen oder das Projekt gelöscht, antwortet der Server 401, und die
 * Oberfläche bietet einen neuen Anfang an. Hier auf Verdacht zu prüfen hieße, jedem
 * Seitenaufruf eine Anfrage voranzustellen, die meistens nichts ändert.
 */
export async function projektId(): Promise<string> {
  const vorhanden = gemerkt();
  if (vorhanden) return vorhanden;
  const neu = await projektAnlegen();
  merken(neu);
  return neu;
}

/** Nach einem 401: das Gemerkte wegwerfen, damit der nächste Versuch neu anfängt. */
export function projektVergessen(): void {
  try {
    localStorage.removeItem(SCHLUESSEL);
  } catch {
    // Siehe `merken`.
  }
}
